import React, { useEffect, useState } from "react";
import { Spinner } from "reactstrap";
import { getFirebaseAuthToken } from "../../../helpers/firebase_helper";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

/**
 * Profile "Details" section showing this national/GA/broker their BaxRx
 * "Connect ID" (integration link token) to paste into a partner platform
 * (e.g. Avero Health), plus their broker signup link.
 */
const IntegrationId = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null); // { linkToken, signupLink }
  const [copied, setCopied] = useState(null);

  const fetchLink = async () => {
    setLoading(true);
    setError(null);
    try {
      const token = await getFirebaseAuthToken();
      const res = await fetch(`${API_BASE}/dashboard/partner-link`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
      });
      if (!res.ok) throw new Error("Could not load your Connect ID");
      setData(await res.json());
    } catch (e) {
      setError(e.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLink();
  }, []);

  const copy = async (value, key) => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(key);
      setTimeout(() => setCopied(null), 1500);
    } catch (e) {
      // clipboard may be unavailable
    }
  };

  return (
    <div className="border rounded-3 p-3">
      <h6 className="mb-1">Integration Connect ID</h6>
      <p className="text-muted small mb-3">
        Paste this ID into your partner platform to link this BaxRx account.
      </p>

      {loading && (
        <div className="py-2">
          <Spinner size="sm" color="primary" /> Loading…
        </div>
      )}

      {error && !loading && (
        <div className="text-danger small">
          {error}{" "}
          <button
            type="button"
            className="btn btn-link btn-sm p-0 align-baseline"
            onClick={fetchLink}
          >
            Retry
          </button>
        </div>
      )}

      {data && !loading && (
        <div style={{ maxWidth: 520 }}>
          <label className="form-label small text-muted mb-1">Connect ID</label>
          <div className="d-flex gap-2">
            <input
              type="text"
              className="form-control form-control-sm"
              readOnly
              value={data.linkToken || ""}
              onFocus={(e) => e.target.select()}
            />
            <button
              type="button"
              className="btn btn-sm btn-primary"
              onClick={() => copy(data.linkToken, "id")}
            >
              {copied === "id" ? "Copied" : "Copy"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default IntegrationId;
